<template>
  <div class="wrapper">
    <div
      class="tabs"
    >
      <label
        v-for="(item, inputIndex) in items"
        :key="inputIndex"
        :class="['tab', {disabled: item.disabled}]"
        :style="tabStyles"
      >
        <input
          v-model="model"
          type="radio"
          :value="item.id"
          name="tabs"
          :disabled="item.disabled"
          @change="selected = inputIndex"
        >
        <div
          class="slider-content"
          :class="{'with-icon': item.icon}"
        >
          <img
            v-if="item.icon"
            height="60"
            :src="item.icon"
          >
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </label>

      <span
        class="glider"
        :style="gliterStyles"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },

  data: () => ({
    selected: 1,
    windowWidth: null,
  }),

  computed: {
    gliterStyles() {
      let translateType = 'translateX';
      if (this.windowWidth < 1024) {
        translateType = 'translateY';
      }
      return {
        transform: `${translateType}(${this.selected * 100}%)`,
        width: this.windowWidth < 1024
          ? '100%'
          : `${100 / this.items.length}%`,
      };
    },

    tabStyles() {
      return {
        width: this.windowWidth < 1024
          ? '100%'
          : `${100 / this.items.length}%`,
      };
    },

    model: {
      get() {
        this.items.forEach((element, index) => {
          if (element.id === this.value) {
            this.selected = index;
          }
        });
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  created() {
    this.windowWidth = window.innerWidth;
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },

};
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: var(--color-blue-400);
  padding: 10px;
  border-radius: 10px;
}

.tabs {
  display: flex;
  position: relative;

  * {
    z-index: 2;
  }
}

input[type="radio"] {
  display: none;
}

.tab {
  cursor: pointer;
  transition: color 0.15s ease-in;
  margin-bottom: 0;
  height: 90px;

  &.disabled {
    opacity: 0.2;

    &:hover {
      cursor: default;
    }
  }
}

.slider-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title {
    font-size: 16px;
    font-family: var(--font-bold);
  }

  .text {
    font-size: 12px;
    font-family: var(--font-medium);
    text-align: center;
    padding: 0 20px;
    margin-top: 5px;
    line-height: 14px;
    color: var(--color-white);
  }

  i {
    font-size: 30px;
    margin-right: 10px;
  }

  &.with-icon {
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .text {
      display: none;
    }
  }
}

.glider {
  position: absolute;
  display: flex;
  height: 90px;
  align-items: center;
  line-height: 1;
  background-color: var(--color-blue-100);
  border: 2px var(--color-secondary) solid;
  z-index: 1;
  transition: 0.25s ease-out;
  border-radius: 10px;
}

@media screen and (max-width: 1024px) {
  .tabs {
    display: flex;
    flex-direction: column;
  }

  .tab {
    width: 100%;
  }

  .glider {
    height: 90px;
    width: 100%;
  }
}
</style>
